import { useExperimentTreatment } from '@ms/yammer-experiments-context';
import { useIsCurrentNetworkInMto } from '@ms/yammer-libs-app-context';
import { isTeamsBrandedExperience } from '@ms/yammer-web-support/dist/teamsBrandedExp';

export const useIsEngageIASimplificationPhase1WithoutReporting = (): boolean => {
  const isEngageIASimplificationPhase1 = useExperimentTreatment('EngageIASimplificationPhase1');
  const shouldForceEngageIASimplificationPhase1ForE2ETests = useExperimentTreatment(
    'ForceEngageIASimplificationPhase1ForE2ETests'
  );
  const isCurrentNetworkInMto = useIsCurrentNetworkInMto();

  return (
    !isTeamsBrandedExperience() &&
    (shouldForceEngageIASimplificationPhase1ForE2ETests || (!isCurrentNetworkInMto && isEngageIASimplificationPhase1))
  );
};
